// App.js
import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./components/HomePage";
import Services from "./components/Services";
import Industries from "./components/Industries";
import Team from "./components/Team";
import ContactUs from "./components/ContactUs";
import LayoutWithHorizontalTabs from "./components/LayoutWithHorizontalTabs"; // Update this import

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LayoutWithHorizontalTabs />}>
          <Route index element={<HomePage />} />
          <Route path="our-services" element={<Services />} />
          <Route path="our-industries" element={<Industries />} />
          <Route path="our-team" element={<Team />} />
          <Route path="contact-information" element={<ContactUs />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
